import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';

import { discoPrototypeRoutes } from 'client/app/apps/disco-prototype/DiscoPrototypeRouter';
type Props = {
  title: string;
};

const PageHeader = ({ title }: Props) => {
  return (
    <Paper elevation={3} sx={{ flexShrink: 0 }}>
      <Toolbar>
        <Typography variant="h1" sx={{ flexGrow: 1, fontWeight: 500 }}>
          {title}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            component={RouterLink}
            to={discoPrototypeRoutes.uploadData.getPath()}
            color="primary"
            variant="text"
          >
            Upload Data
          </Button>
          <Button
            component={RouterLink}
            to={discoPrototypeRoutes.defineLiguidSet.getPath()}
            color="primary"
            variant="text"
          >
            Liquid Sets
          </Button>
        </Box>
      </Toolbar>
    </Paper>
  );
};

export default PageHeader;
